// extracted by mini-css-extract-plugin
export var cardLayout = "_5c-1";
export var paginationContainer = "_5c-0";